import { Eyebrow } from "@/components/media/Sections";
import { Check, Star } from "lucide-react";

export const CateringPackages = ({ packages }) => {
  if (!packages) return null;
  const list = packages.packages || [];
  const services = packages.services || [];

  return (
    <>
      <Eyebrow>CATERING PACKAGES</Eyebrow>
      <h2 className="neon mt-3 max-w-3xl text-4xl leading-tight sm:text-5xl">{packages.title}</h2>
      <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">{packages.intro}</p>

      <div className="mono mt-12 text-[11px] tracking-[0.35em] text-primary">
        {(packages.step_one || "").toUpperCase()}
      </div>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((p) => (
          <div
            key={p.id}
            data-testid={`package-${p.id}`}
            className={`relative flex flex-col border bg-[#141414] p-6 transition-colors ${
              p.badge ? "border-primary" : "border-border hover:border-primary/60"
            }`}
          >
            {p.badge ? (
              <span className="mono absolute -top-3 left-6 flex items-center gap-1 bg-primary px-2 py-1 text-[9px] tracking-widest text-primary-foreground">
                <Star size={10} fill="currentColor" /> {p.badge}
              </span>
            ) : null}
            <h3 className="display text-2xl uppercase leading-none md:text-3xl">{p.name}</h3>
            <div className="mono mt-2 text-[11px] tracking-widest text-muted-foreground">
              {(p.drinks || "").toUpperCase()}
            </div>
            <div className="display mt-5 text-4xl leading-none text-primary">{p.price}</div>
          </div>
        ))}
      </div>
      {packages.per_drink_note ? (
        <p data-testid="per-drink-note" className="mono mt-6 text-[11px] tracking-widest text-primary">
          {packages.per_drink_note.toUpperCase()}
        </p>
      ) : null}

      <div className="mono mt-16 text-[11px] tracking-[0.35em] text-primary">
        {(packages.step_two || "").toUpperCase()}
      </div>
      <div className="mt-6 grid gap-4 lg:grid-cols-3">
        {services.map((s) => (
          <div
            key={s.id}
            data-testid={`service-${s.id}`}
            className="group flex flex-col overflow-hidden border border-border bg-[#141414] transition-colors hover:border-primary"
          >
            {s.image ? (
              <div className="h-44 overflow-hidden bg-black">
                <img src={s.image} alt="" loading="lazy"
                  className="h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
              </div>
            ) : null}
            <div className="flex flex-1 flex-col p-6">
              <h3 className="display text-2xl uppercase leading-none">{s.name}</h3>
              <div className="display mt-2 text-3xl leading-none text-primary">{s.price_label}</div>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">{s.blurb}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-16 grid gap-10 border-t border-border pt-10 lg:grid-cols-2">
        <div>
          <div className="mono text-[11px] tracking-[0.35em] text-primary">
            {(packages.includes_title || "").toUpperCase()}
          </div>
          <ul className="mt-5 space-y-3">
            {(packages.includes || []).map((inc) => (
              <li key={inc} className="flex items-start gap-3 text-base text-white">
                <Check size={15} className="mt-1 shrink-0 text-primary" />
                {inc}
              </li>
            ))}
          </ul>
        </div>
        <div data-testid="catering-upgrades">
          <div className="mono text-[11px] tracking-[0.35em] text-primary">
            {(packages.upgrades_title || "").toUpperCase()}
          </div>
          <p className="mt-3 text-base text-muted-foreground">{packages.upgrades_intro}</p>
          <ul className="mt-5 divide-y divide-border/60 border-y border-border/60">
            {(packages.upgrades || []).map((u) => (
              <li key={u.id} data-testid={`upgrade-${u.id}`} className="flex flex-wrap items-baseline justify-between gap-2 py-3">
                <span className="text-base text-white">{u.label}</span>
                <span className="mono text-[11px] tracking-widest text-primary">{u.price_note}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 border-l-2 border-border pl-6">
        <div className="mono text-[11px] tracking-[0.35em] text-muted-foreground">
          {(packages.booking_info_title || "").toUpperCase()}
        </div>
        <ul data-testid="booking-info" className="mt-4 space-y-2">
          {(packages.booking_info || []).map((n) => (
            <li key={n} className="mono text-[11px] leading-relaxed tracking-widest text-muted-foreground">
              {n}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export const CateringFaq = ({ faq }) => {
  if (!faq?.items?.length) return null;
  return (
    <>
      <Eyebrow>GOOD QUESTIONS</Eyebrow>
      <h2 className="neon mt-3 text-4xl leading-tight sm:text-5xl">{faq.title}</h2>
      <div className="mt-10 divide-y divide-border border-y border-border">
        {faq.items.map((item) => (
          <details key={item.id} data-testid={`catering-faq-${item.id}`} className="group py-5">
            <summary className="display cursor-pointer list-none text-xl uppercase leading-tight text-white transition-colors group-open:text-primary md:text-2xl">
              {item.q}
            </summary>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-muted-foreground">
              {item.a}
            </p>
          </details>
        ))}
      </div>
    </>
  );
};
